/** @format */

import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactComponent as QuestionCircle } from "bootstrap-icons/icons/question-circle.svg";
import { ReactComponent as ArrowRepeat } from 'bootstrap-icons/icons/arrow-repeat.svg';
import { Markup } from "interweave";

type Props = {
  tooltipText: string;
  type?: "help" | "sync" | "conditionalSync"
};

const HelperTooltip: React.FC<Props> = ({ tooltipText, type="help" }) => {
  const icon = () => {
    switch (type) {
      case "sync":
        case "conditionalSync": 
        return <ArrowRepeat className={`text-editing ml-1 ms-2`}/>
      default: 
        return <QuestionCircle className="ml-1 ms-2" />
    }
  }

  return (
    <OverlayTrigger
      placement="right"
      overlay={
        <Tooltip id="module-name-help" data-testid="tooltip">
          {
            <>
              <Markup content={tooltipText} />
            </>
          }
        </Tooltip>
      }
    >
      { icon() }
    </OverlayTrigger>
  );
};

export default HelperTooltip;
